import React from 'react'

const CQMenu = ({handleLeadTypeSelect, activeTab}) => {
    return (
        <>
            <ul className="nav nav-tabs d-block" id="myTab11" role="tablist">
                <li className="nav-item text-uppercase" role="presentation">
                    <button className="nav-link cql-header text-uppercase active" type="button">Appraisals in Queue</button>
                </li>
                <li className="nav-item" role="presentation">
                    <button className={`nav-link cql-inner ${activeTab.location === "BOYNTON BEACH" && activeTab.stage === "InQueue" && activeTab.lead_type === "InPerson" ? "active" : ""}`} type="button" 
                    onClick={() => handleLeadTypeSelect("BOYNTON BEACH","InQueue","InPerson")}>Boynton Beach</button>
                </li>
                <li className="nav-item" role="presentation">
                    <button className={`nav-link cql-inner ${activeTab.location === "POMPANO BEACH" && activeTab.stage === "InQueue" && activeTab.lead_type === "InPerson" ? "active" : ""}`} type="button" 
                    onClick={() => handleLeadTypeSelect("POMPANO BEACH","InQueue","InPerson")}>Pompano Beach</button>
                </li>
                <li className="nav-item" role="presentation">
                    <button className={`nav-link cql-inner ${activeTab.stage === "WebAppointments" ? "active" : ""}`} type="button" 
                    onClick={() => handleLeadTypeSelect("","WebAppointments","")}>Web Appointments</button>
                </li>

                <li className="nav-item mt-3 text-uppercase" role="presentation"  style={{marginTop: "2px"}}>
                    <button className="nav-link cql-header text-uppercase active" type="button">Appraisals in Progress</button>
                </li>
                <li className="nav-item" role="presentation">
                    <button className={`nav-link cql-inner ${activeTab.location === "BOYNTON BEACH" && activeTab.stage === "InProgress" && activeTab.lead_type === "InPerson" ? "active" : ""}`} type="button" 
                    onClick={() => handleLeadTypeSelect("BOYNTON BEACH","InProgress","InPerson")}>Boynton Beach</button>
                </li>
                <li className="nav-item" role="presentation">
                    <button className={`nav-link cql-inner ${activeTab.location === "POMPANO BEACH" && activeTab.stage === "InProgress" && activeTab.lead_type === "InPerson" ? "active" : ""}`} type="button" 
                    onClick={() => handleLeadTypeSelect("POMPANO BEACH","InProgress","InPerson")}>Pompano Beach</button>
                </li>

                <li className="nav-item mt-3 text-uppercase" role="presentation"  style={{marginTop: "2px"}}>
                    <button className="nav-link cql-header text-uppercase active" type="button">Completed Appraisals</button>
                </li>
                <li className="nav-item" role="presentation">
                    <button className={`nav-link cql-inner ${activeTab.location === "BOYNTON BEACH" && activeTab.stage === "Completed" && activeTab.lead_type === "InPerson" && !activeTab.status ? "active" : ""}`} type="button" 
                    onClick={() => handleLeadTypeSelect("BOYNTON BEACH","Completed","InPerson")}>Boynton Beach</button>
                </li>
                <li className="nav-item" role="presentation">
                    <button className={`nav-link cql-inner ${activeTab.location === "POMPANO BEACH" && activeTab.stage === "Completed" && activeTab.lead_type === "InPerson" && !activeTab.status ? "active" : ""}`} type="button" 
                    onClick={() => handleLeadTypeSelect("POMPANO BEACH","Completed","InPerson")}>Pompano Beach</button>
                </li>

                <li className="nav-item mt-3 text-uppercase" role="presentation"  style={{marginTop: "2px"}}>
                    <button className="nav-link cql-header text-uppercase active" type="button">CallBack Clients</button>
                </li>
                <li className="nav-item" role="presentation">
                    <button className={`nav-link cql-inner ${activeTab.location === "BOYNTON BEACH" && activeTab.stage === "Callback" && activeTab.lead_type === "InPerson" ? "active" : ""}`} type="button" 
                    onClick={() => handleLeadTypeSelect("BOYNTON BEACH","Callback","InPerson")}>Boynton Beach</button>
                </li>
                <li className="nav-item" role="presentation">
                    <button className={`nav-link cql-inner ${activeTab.location === "POMPANO BEACH" && activeTab.stage === "Callback" && activeTab.lead_type === "InPerson" ? "active" : ""}`} type="button" 
                    onClick={() => handleLeadTypeSelect("POMPANO BEACH","Callback","InPerson")}>Pompano Beach</button>
                </li>

                <li className="nav-item mt-3 text-uppercase" role="presentation"  style={{marginTop: "2px"}}>
                    <button className="nav-link cql-header text-uppercase active" type="button">Bought Vehicles</button>
                </li>
                <li className="nav-item" role="presentation">
                    <button className={`nav-link cql-inner ${activeTab.location === "BOYNTON BEACH" && activeTab.status == "Bought" ? "active" : ""}`} type="button" 
                    onClick={() => handleLeadTypeSelect("BOYNTON BEACH","Completed","InPerson","Bought")}>Boynton Beach</button>
                </li>
                <li className="nav-item" role="presentation">
                    <button className={`nav-link cql-inner ${activeTab.location === "POMPANO BEACH" && activeTab.status == "Bought" ? "active" : ""}`} type="button" 
                    onClick={() => handleLeadTypeSelect("POMPANO BEACH","Completed","InPerson","Bought")}>Pompano Beach</button>
                </li>
            </ul>
        </>
    )
}

export default CQMenu